import React from "react";
import * as s from "./paletteStyle";

function Palette({
  colors1,
  colors2,
  title,
  handleOpenChromePicker,
  handleInputChange,
  activeColor,
  setActiveColor,
  onTileClick,
}) {
  const onHover = (color) => {
    if (color !== activeColor) {
      document.activeElement.blur();
    }
  };
  return (
    <s.PaletteContainer>
      <s.Tiles>
        {colors1.map(({ value }) => (
          <s.Tile
            key={value}
            onClick={() => onTileClick(value)}
            onMouseOver={() => onHover(value)}
            className={value === activeColor ? "active" : "inactive"}
            $background={value}
          >
            <s.Label className="label">선택</s.Label>
          </s.Tile>
        ))}
      </s.Tiles>
      <s.Tiles>
        {colors2.map(({ value }) => (
          <s.Tile
            key={value}
            onClick={() => onTileClick(value)}
            onMouseOver={() => onHover(value)}
            className={value === activeColor ? "active" : "inactive"}
            $background={value}
          >
            <s.Label className="label">선택</s.Label>
          </s.Tile>
        ))}
      </s.Tiles>
      <s.PaletteInfo className="palette-info">
        <span onClick={handleOpenChromePicker} style={{ cursor: "pointer" }}>
          {title}
        </span>
        <div>
          선택한 색상 &nbsp;
          {activeColor && (
            <>
              <s.TileSmall
                className="tile-sm"
                style={{ background: activeColor }}
              />
            </>
          )}
        </div>
      </s.PaletteInfo>
    </s.PaletteContainer>
  );
}

export default Palette;
